"use client";

import {
  RESIDENT_ROUTES,
  ForgotPasswordForm as SharedForgotPasswordForm,
} from "@pulseprep/shared-ui";
import { useResidentForgotPassword } from "@pulseprep/shared-ui/hooks";

export function ForgotPasswordForm() {
  const { forgotPassword, isLoading } = useResidentForgotPassword();

  return (
    <SharedForgotPasswordForm
      forgotPasswordFn={forgotPassword}
      isLoading={isLoading}
      loginHref={RESIDENT_ROUTES.login}
    />
  );
}
